
  <form class="dynamic-form" [formGroup]="form" (submit)="onSubmit($event)">
  <div class="form-group" *ngFor="let field of fields;">
  <ng-container dynamicField [field]="field" [group]="form">
  </ng-container>
  </div>
  </form>
  